module.exports = __webpack_public_path__ + "img/bereket-sigorta.6ed61be1.png";